import * as React from "react";
import { connect } from "react-redux";
import { RouterState } from "react-router-redux";

import { history } from "../../../store";
import { RootState, Dispatch } from "../../../store/types";
import NavItem, { WizardNavItemDerivedState as NavItemState } from "./NavItem";
import Wizard from "./Wizard";
import * as constants from "../constants";
import * as selectors from "../selectors";
import * as routingSelectors from "../../../store/selectors";

export interface WizardContainerProps extends RouterState {
  navItemStates: {
    [stepCount: string]: NavItemState;
  };
}

class WizardContainer extends React.Component<WizardContainerProps, {}> {
  public render() {
    return <Wizard navItems={this.renderNavItems()} />;
  }

  private renderNavItems = () =>
    constants.NAV_ITEMS.map((data, i) => (
      <NavItem
        key={i}
        onClick={this.getNavItemOnClick(data.pathname)}
        {...this.props.navItemStates[data.step]}
        {...data}
      />
    ));

  private getNavItemOnClick = (pathname: string) => () =>
    history.push(pathname);
}

const mapStateToProps = (state: RootState): Partial<WizardContainerProps> => ({
  location: routingSelectors.location(state),
  navItemStates: {
    "1": selectors.step1NavItem(state),
    "2": selectors.step2NavItem(state),
    "3": selectors.step3NavItem(state),
    "4": selectors.step4NavItem(state),
    "5": selectors.step5NavItem(state),
  },
});

const mapDispatchToProps = (
  dispatch: Dispatch,
): Partial<WizardContainerProps> => ({});

export default connect(mapStateToProps, mapDispatchToProps)(WizardContainer);



// WEBPACK FOOTER //
// ./src/routes/Wizard/components/WizardContainer.tsx